import { auth, functionsBaseUrl } from "../../firebase";
import { CreateStaffAccountRequest, CreateStaffAccountResponse, staffMapping } from "../../models/staffMapping";

export const createStaffAccount = async (
  input: CreateStaffAccountRequest
): Promise<CreateStaffAccountResponse> => {
  if (!auth.currentUser) {
    return { success: false, error: "Not signed in" };
  }

  const idToken = await auth.currentUser.getIdToken();

  const response = await fetch(`${functionsBaseUrl}/createStaffAccount`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(input),
  });

  if (response.status == 500) {
    throw new Error((await response.json() as CreateStaffAccountResponse).error)
  }

  return (await response.json()) as CreateStaffAccountResponse;
};
